import dynamic from "next/dynamic";
import { useTranslation } from "react-i18next";
import ToResolveClassNameError from "../../components/hoc/ToResolveClassNameError";
import ExpiredJobWrapper from "../../components/jobs/ExpiredJobWrapper/ExpiredJobWrapper";
import SingleJobWrapper from "../../components/jobs/SingleJobWrapper/SingleJobWrapper";
import SharedJobHeader from "../../components/shared/SharedHeader/SharedJobHeader/SharedJobHeader";
import SharedNavbar2 from "../../components/shared/SharedNavbar/Navbar/Navbar";
import JDPUploadResumeFloating from "../../components/shared/UploadResumeFloating/wrappers/JDPUploadResumeFloating";
import {
  getJobWithoutRedux,
  getPostApplyRecommendedJobsWithoutRedux
} from "../../redux/actions/job_action";

const SharedFooter = dynamic(() =>
  import("../../components/shared/SharedFooter/SharedFooter")
);

const Toolbar = dynamic(() => import("@mui/material/Toolbar"));

function JobProfile(props) {
  const { t } = useTranslation();
  return (
    <div aria-label="job-detail-body">
      <SharedJobHeader job={props.job} />
      <ToResolveClassNameError>
        <SharedNavbar2
          page="single-job-page"
          breadcrumbItems={[
            { label: t("nav.jobs"), href: "/jobs" },
            { label: props.job?.title },
          ]}
        />
      </ToResolveClassNameError>
      <Toolbar
        sx={{
          "@media(min-width: 1280px)": {
            // minHeight: "64px",
            minHeight: "104px !important",
          },
          "@media(max-width: 1279px)": {
            // minHeight: "52px",
            minHeight: "92px !important",
          },
          "@media(max-width: 639px)": {
            // minHeight: "60px",
            minHeight: "100px !important",
          },
        }}
      />

      {props.jobExpired ? (
        <ExpiredJobWrapper
          job={props.job}
          similarJobs={props.similarJobs}
        />
      ) : (
        <SingleJobWrapper
          job_slug={props.id}
          serverJob={props.job}
        />
      )}
      <ToResolveClassNameError>
        <SharedFooter />
        <JDPUploadResumeFloating />
      </ToResolveClassNameError>
    </div>
  );
}

export async function getServerSideProps({ params, res }) {
  const job = await getJobWithoutRedux({
    jobId: params.id,
    canCancel: false,
  });

  // For NO JOB RECORD: display 404 page
  if (job?.jobNotFound) {
    return {
      notFound: true,
    };
  }

  const isUnavailable =
    job?.expired === true ||
    job?.active === false;

  if (isUnavailable) {
    //This one is for job who are existed, but arent available anymore (expired/inactive)
    res.statusCode = 404;

    let similarJobs = [];

    if (job.globalId) {
      try {
        const recommendations =
          await getPostApplyRecommendedJobsWithoutRedux({
            globalId: job.globalId,
            first: 9,
          });

        similarJobs = (recommendations ?? []).filter(
          (similarJob) =>
            similarJob.active === true &&
            similarJob.expired === false
        );
      } catch {
        console.error(
          "Failed to fetch unavailable-job recommendations"
        );
      }
    }

    return {
      props: {
        id: params.id,
        job,
        jobExpired: true,
        similarJobs,
      },
    };
  }

  return {
    props: {
      id: params.id,
      job,
      jobExpired: false,
      similarJobs: [],
    },
  };
}

export default JobProfile;
